/**
 * Returns a shallow copy of `obj` with every `null` property value replaced by
 * `undefined`. Useful for API payloads where `null` and "not provided" should
 * be treated the same.
 *
 * The return type is the input type, so the result stays assignable to
 * whatever the caller was already passing around. Note this is a widening
 * lie for properties typed as `null` only — they hold `undefined` at runtime.
 */
export function nullsToUndefined<T extends object>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      value === null ? undefined : value,
    ]),
  ) as T;
}
